/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { PriceComponent } from '../../../nickComponents/absoluteheadprice.components';
import * as React from 'react';

import { IGetOrderSummaryInput, IOrderSummary, IPriceContext } from '@msdyn365-commerce-modules/order-management';

interface ISummaryLineProps {
    priceContext?: IPriceContext;
    name: string;
    label: string;
    value?: number;
}

const OrderSummaryLine: React.SFC<ISummaryLineProps> = ({ value = 0, priceContext }) => (
    <>
        {priceContext ? (
             
            <PriceComponent
                {...priceContext}
                className='nickNewPrice'
                data={{ price: { CustomerContextualPrice: value } }}
            />
           
        ) : (
            "nick Test"
        )}
    </>
);

export const getOrderConfirmationOrderSummary = ({
    order,
    priceContext,
    earnedPoints,
    resource: {
        orderSummaryHeading,
        orderSummaryItemsTotalLabel,
        orderSummaryShippingFeeLabel,
        orderSummaryTaxLabel,
        orderSummaryGrandTotalLabel,
        pointsEarnedLabel
    },
    canShip,
    isTaxIncludedInPrice,
    isShowTaxBreakUp
}: IGetOrderSummaryInput): IOrderSummary => {

    const subTotal = isTaxIncludedInPrice && isShowTaxBreakUp ? order.SubtotalAmountWithoutTax: order.SubtotalAmount;
    const taxOnShippingCharge = order.TaxOnShippingCharge !== undefined ? order.TaxOnShippingCharge : 0;
    const shippingChargeAmount = order.ShippingChargeAmount !== undefined ? order.ShippingChargeAmount : 0;

    const freightFee = isTaxIncludedInPrice && isShowTaxBreakUp ? order.ShippingChargeAmount : shippingChargeAmount + taxOnShippingCharge;
    return {
        orderSummaryProps: { className: '' },
        heading: <p className='ms-order-confirmation__order-summary-heading'>
            {orderSummaryHeading}
        </p>,
        subtotal: (
            <OrderSummaryLine
                name='subtotal'
                label={orderSummaryItemsTotalLabel}
                value={subTotal}
                priceContext={priceContext}
            />
        ),
        shipping: canShip ? (
            <OrderSummaryLine
                name='shipping' label={orderSummaryShippingFeeLabel} value={freightFee}
                priceContext={priceContext} />
        ) : '',
        tax: isShowTaxBreakUp ? (<OrderSummaryLine
            name='tax-amount' label={orderSummaryTaxLabel} value={order.TaxAmount}
            priceContext={priceContext} />
        ) : '',
        totalAmount: (
            <OrderSummaryLine
                name='total-amount'
                label={orderSummaryGrandTotalLabel}
                value={order.TotalAmount}
                priceContext={priceContext}
            />
        ),
        earnedPoints: earnedPoints ? <OrderSummaryLine name='earned-points' label={pointsEarnedLabel} value={earnedPoints} /> : undefined
    };
};
